module.exports = __webpack_public_path__ + "static/img/JXS.368462e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/supplyHome/JXS.jpg
// module id = qvhB
// module chunks = 2